import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Data2Service } from '../../common/data2.service';
import { InfoboxService } from '../../common/infobox/infobox.service';
import {
	TourismTransportFiltersComponent as FiltersComponent,
	TourismTransportFiltersComponent,
} from '../tourism-transport-list/tourism-transport-filters/tourism-transport-filters.component';

@Component({
	selector: 'app-tourism-transport-list',
	templateUrl: './tourism-transport-list.component.html',
	styleUrls: ['./tourism-transport-list.component.css'],
})
export class TourismTransportListComponent implements OnInit {
	private itemsBeforeDataLoad = 2;
	loader = true;
	id = 0;
	data: Array<any> = [];
	dataSms: Array<any> = [];
	vehicles: Array<any> = [];
	originCityId: Array<any> = [];
	offerName: Array<any> = [];
	timetable;
	elements: Array<any> = [];
	showElements: Array<any> = [];
	filters;
	parameter;
	tableRows = {
		destination: [
			{ id: 'originCity', name: 'Miasto wyjazdu' },
			{ id: 'status', name: 'Status' },
			{ id: 'unique', name: 'Unikat' },
			{ id: 'businessCaseNumber', name: 'BC' },
			{ id: 'firstName', name: 'Imie' },
			{ id: 'lastName', name: 'Nazwisko' },
			{ id: 'reservationsCount', name: 'il.rez' },
			{ id: 'empty', name: 'Miejsce' },
			{ id: 'services', name: 'PAK' },
			{ id: 'phone', name: 'TEL' },
			{ id: 'offerName', name: 'Produkt' },
			{ id: 'note', name: 'Notatka' },
			{ id: 'meal', name: 'Wyżywienie' },
			{ id: 'accommodation', name: 'Zakwaterowanie' },
			{ id: 'ant', name: 'ANT' },
			{ id: 'empty', name: 'ANT2' },
			{ id: 'pl', name: 'PL' },
			{ id: 'empty', name: 'PL2' },
			{ id: 'cel', name: 'CEL' },
			{ id: 'empty', name: 'CEL2' },
			{ id: 'sameCity', name: 'Inne Miasta' },
		],
		passport: [
			{ id: 'firstName', name: 'Imie' },
			{ id: 'lastName', name: 'Nazwisko' },
			{ id: 'birthDate', name: 'Data ur.' },
			{ id: 'cel', name: 'Pojazd' },
			{ id: 'offerName', name: 'Produkt' },
			{ id: 'accommodation', name: 'Zakwaterowanie' },
		],
		charges: [
			{ id: 'firstName', name: 'Imie' },
			{ id: 'lastName', name: 'Nazwisko' },
			{ id: 'birthDate', name: 'Data ur.' },
			{ id: 'businessCaseNumber', name: 'BC' },
			{ id: 'costs', name: 'Koszty Pro.' },
			{ id: 'offerNights', name: 'Noclegów' },
			{ id: 'empty', name: 'Podpis' },
			{ id: 'vehicle', name: 'Pojazd' },
			{ id: 'offerName', name: 'Produkt' },
			{ id: 'meal', name: 'Wyżywienie' },
			{ id: 'note', name: 'Notatka' },
			{ id: 'accommodation', name: 'Zakwaterowanie' },
		],
		tgs: [
			{ id: 'firstName', name: 'Imie' },
			{ id: 'lastName', name: 'Nazwisko' },
			{ id: 'businessCaseNumber', name: 'BC' },
			{ id: 'empty', name: 'Podpis przyjacia' },
			{ id: 'empty', name: 'Podpis oddania' },
		],
		sms: [
			{ id: 'businessCaseNumber', name: 'BC' },
			{ id: 'phone', name: 'TEL' },
			{ id: 'originCity', name: 'Miasto wyjazdu' },
			{ id: 'detail', name: 'Adres' },
			{ id: 'date', name: 'Data' },
			{ id: 'time', name: 'Godzina' },
			{ id: 'productName', name: 'Produkt' },
		],
	};

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params.id) {
			return;
		}
		this.id = this.route.snapshot.params.id;
		this.api.get('/tourismTimetable/' + this.id + '/', (result, error) => {
			result.data.sideName = result.data.side == 'departure' ? 'Wyjazd' : 'Powrót';
			this.timetable = result.data;
			this.api.get('/vehicles/', (result, error) => {
				this.vehicles = result.data;
			});
			this.api.get('/tourismStops/', (result, error) => {
				this.originCityId = result.data;
			});
			this.api.command('/istourOffers', this.data, (result, error) => {
				this.offerName = result.data;
			});
			this.loadData();
		});
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader = true;
		const transportsOrder = ['ant', 'ant2', 'pl'];
		const parms: string = this.getChecked();
		this.api.get('/tourismTransportLists/' + this.id + '/?' + parms, (result, error) => {
			let pos = 0;
			let haveAnt2 = false;
			const havePl = false;
			result.data.forEach((obj) => {
				pos++;
				obj.pos = pos;
				obj.cel = obj.transports[obj.transports.length - 1];
				for (let i = obj.transports.length - 2; i >= 0; i--) {
					obj[transportsOrder[i]] = obj.transports[i];
				}
				if (!haveAnt2 && obj.transports.length > 2) {
					haveAnt2 = true;
				}
				obj.services = obj.services.join();
				obj.empty = '';
				obj.costs = '?';
				obj.phone.forEach((phone, index) => {
					obj.phone[index] = phone.replace(/-|\s/g, '');
				});
				if (
					result.data.find(
						(objFind) =>
							objFind.businessCaseId == obj.businessCaseId && objFind.originCity != obj.originCity,
					)
				) {
					obj.sameCity = 'inne miasta';
				} else {
					obj.sameCity = '';
				}
				obj.reservationsCount = result.data.filter((val) => {
					return val.businessCaseNumber == obj.businessCaseNumber;
				}).length;
				obj.unique = obj.businessCaseNumber + obj.firstName + obj.lastName;
				obj.vehicle = this.findVehicleForReservation(obj.businessCaseNumber);
				if (!obj.originCity) {
					console.log(obj);
					this.infobox.error('Brak miasta dla rezerwacji nr ' + obj.businessCaseNumber);
				}
			});
			this.data = result.data;
			// hide ant2 field if nobody have it
			if (!haveAnt2) {
				this.tableRows.destination = this.tableRows.destination.filter((obj) => {
					return obj.id !== 'ant2';
				});
			}
			this.elements = result.data;
			this.showElements = this.elements;
			this.loader = false;
			this.changeTab('destination');
		});
	}

	getChecked(): string {
		let checked = '';
		for (const key in this.filters) {
			switch (key) {
				default:
					if (this.filters[key]?.length) {
						checked += '&' + key + '=' + this.filters[key];
					}
					break;
			}
		}
		return checked.replace(/^&/, '');
	}

	filtersOpen() {
		new TourismTransportFiltersComponent(this.api, this.route, this.router).filtersOpen();
	}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}

	private findVehicleForReservation(businessCaseNumber) {
		const action = this.timetable.actions.find((findObj) => findObj.reservation == businessCaseNumber);
		if (!action) {
			return '';
		}
		const transport = this.timetable.transports.find((findObj) => findObj.id == action.transport);
		if (!transport) {
			return '';
		}
		const vehicle = this.vehicles.find((findObj) => findObj.id == transport.vehicle);
		return vehicle?.name;
	}

	changeTab(tab: string) {
		switch (tab) {
			case 'destination':
				// sort by date & originCity & businessCaseNumber
				this.data = this.data
					.sort((a, b) => {
						return a.businessCaseNumber - b.businessCaseNumber;
					})
					.sort((a, b) => {
						return a.originCity.toLowerCase().localeCompare(b.originCity.toLowerCase());
					})
					.sort((a, b) => {
						return a.timestamp - b.timestamp;
					});
				break;
			case 'passport':
			case 'charges':
			case 'tgs':
				this.data = this.data.sort((a, b) => {
					return a.lastName.toLowerCase().localeCompare(b.lastName.toLowerCase());
				});
				break;
			case 'sms':
				this.dataSms = [];
				this.data.forEach((obj) => {
					obj.phone.forEach((phone) => {
						const className = obj.phone.length > 1 ? 'table-info' : null;
						this.dataSms.push({
							businessCaseNumber: obj.businessCaseNumber,
							phone: phone,
							originCity: obj.originCity,
							detail: obj.detail,
							date: obj.date,
							time: obj.time,
							productName: obj.productName,
							class: className,
						});
					});
				});
				break;
		}
	}
}
